import React, { PropTypes, Component } from 'react'
import {Link, withRouter} from 'react-router-dom';
import Phone from 'react-icons/lib/fa/phone'
import Facebook from 'react-icons/lib/fa/facebook'
import Twitter from 'react-icons/lib/fa/twitter'
import Instagram from 'react-icons/lib/fa/instagram'
import Youtube from 'react-icons/lib/fa/youtube-play'
import Pinterest from 'react-icons/lib/fa/pinterest-p'
import GooglePlus from 'react-icons/lib/fa/google-plus'
import Tumblr from 'react-icons/lib/fa/tumblr'
import Arrow from 'react-icons/lib/io/chevron-right';
import withMedia from '../../../containers/withmedia';
import withPage from '../../../containers/withpage';
import style from './style.css'
import liststyle from '../../pagescreen/listarrow/style.css'


class Footer extends Component {

    constructor(props){
        super(props)
        this.partners = this.partners.bind(this);
    }
    lists(){
        return(
            <div className={ style.lists }>
                <div className={ style.list }>
                    <h4> مجلة حواء </h4>
                    <ul>
                        <li><Link to={ `/` }>تحقيقا</Link></li>
                        <li><Link to={ `/` }>حوارات</Link></li>
                        <li><Link to={ `/` }>صحتك</Link></li>
                        <li><Link to={ `/` }>أناقة و جمال</Link></li>
                        <li><Link to={ `/` }>نجوم و فنون</Link></li>
                        <li><Link to={ `/` }>أيام و ليالي</Link></li>
                    </ul>
                </div>
                <div className={ style.list }>
                    <h4> أبواب ثابتة </h4>
                    <ul>
                        <li><Link to={ `/` }>قلوب حائرة</Link></li>
                        <li><Link to={ `/` }>أنت و طفلك</Link></li>
                        <li><Link to={ `/` }>ديكور</Link></li>
                        <li><Link to={ `/` }>مستشارك القانوني</Link></li>
                        <li><Link to={ `/` }>تفصيل</Link></li>
                        <li><Link to={ `/` }>5 سياحة</Link></li>
                    </ul>
                </div>
            </div>
        )
    }

    socialLinks(){
      const { page, resort } = this.props
      console.log("Footer page: ", page)
      console.log("Footer Resort: ", resort)
      const overview = resort && resort.overview ? resort.overview : page
      return(
          <div>
          { true 
            ? <div className={ style.socialLinks }>
                <ul>
                  { <li className={ style.facebook }><a target="_blank" href={ "https://www.facebook.com/%D9%85%D8%AC%D9%84%D9%87-%D8%AD%D9%88%D8%A7%D8%A1-452818321745137/" }><Facebook /></a></li> }
                </ul>
                <p>انضم إلي صفحة مجلة حواء على الفيسبوك</p>
              </div>
            : <div></div>
          }
          </div>
        )
    }

    contactus(){
        return(
            <div className={ style.contactus }>
            </div>
        )
    }
    hotline(){
        return(
            <div className={ style.hotline }>
            </div>
        )
    }
    lessThanMedium(){
        return(
            <div className={ style.inner }>
                { this.lists() }
                { this.socialLinks() }
                { this.copyright() }
            </div>
        )
    }
    greaterThanMedium(){
        return(
            <div className={ `${style.inner} container` }>
            { this.contactus() }
            { this.lists() }
            { this.mobileApp() }
            { this.partners() }
            { this.socialLinks() }
            { this.copyright() }
            </div>
        )
    }
    partners(){
        return(
            <div className={ style.partnersContainer }> 
              <div className={ style.partners }>
                <img src="https://www.sunrise-resorts.com/images/sunrise_partners_g.png" />
                <a className={ `${style.partner} ${style.sunrise}` } href="http://www.sunrise-resorts.com"></a>
                <a className={ `${style.partner} ${style.smartlineColorBeach }` } href="http://www.sunrise-resorts.com"></a>
                <a className={ `${style.partner} ${ style.festival }` } href="http://www.sunrise-resorts.com"></a>
              </div>
            </div>
        )
    }
    copyright(){
        return(
            <div className={ style.copyright } >
                <div>
                   جميع الحقوق محفوظة - مجلة حواء &#169;{ (new Date()).getFullYear() } 
                </div>
            </div>
        )
    }
    mobileApp(){
        return(
            <div className={ style.mobileAppContainer }>
                <h4> Coming Soon</h4>
                <div className={ style.mobileApp }>
                    <div className={ style.mobile }></div>
                    <div className={ style.title }>Sunrise Mobile App</div>
                    <div className={ style.subtitle }>Your next personalized stay is a tap away</div>
                    <div className={ style.stores }></div>
                </div>
            </div>
        )
    }
    layout(){
        return (
            <div className={ style.container }>
                { this.props.browser.greaterThan.medium && this.greaterThanMedium() }
                { this.props.browser.lessThan.large && this.lessThanMedium() }
            </div>
        )
    }
    render() {
        return (
            <div className={ style.footer }>
                { this.layout() }
            </div>
        )
    }
}

const fragment = `  title
                    slug
                    id
                    db_id
                    resort_address
                    resort_facebook
                    resort_twitter
                    resort_instagram
                    resort_tumblr
                    resort_youtube
                    resort_pinterest
                    resort_google_plus
                    overview: page(slug: \"overview\"){
                      resort_address
                      resort_facebook
                      resort_twitter
                      resort_instagram
                      resort_tumblr
                      resort_youtube
                      resort_pinterest
                      resort_google_plus
                    }
                    `

const EnhancedFooter = (props) => {
    const {slug, resort} = props
    const default_slug = (resort || slug) ? null : "frontpage"
    //console.log("Footer Enhanced slug: " + JSON.stringify(default_slug))
    const Comp = withRouter(withMedia(withPage(Footer, { fragment: fragment, slug: default_slug  } )))
    return (
        <div>
            <Comp {...props}/>
        </div>
    )
}

export default EnhancedFooter 



// WEBPACK FOOTER //
// ./src/components/homescreen/footer/index.js